(() => {
  const cartPromise = fetch('/cart.js')
  const duplicateLinks = document.querySelectorAll('a[href="#duplicate"]')
  duplicateLinks.forEach(link => {
    const lineItemKey = link.getAttribute('data-line-item-key')
    if(!!lineItemKey === false) return
    link.addEventListener('click', async  e => {
      e.preventDefault()
      link.setAttribute('disabled', '')
      const response = await cartPromise
      const cart = await response.json()
      const itemToDuplicate = cart.items.find(item => item.key === lineItemKey)

      let addedItemsData = {
       'items': [{
        'id': itemToDuplicate.id,
        'quantity': 1,
         'properties': {
           ...itemToDuplicate.properties,
           '_duplicate_id': (Math.random() + 1).toString(36).substring(2)
         }
        }]
      };
      await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(addedItemsData)
      })

      location.reload()
    })
  })
})()